export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5407.6001e249.jpg";